import { useFitZoom } from "../../hooks/useFitZoom.ts";
import { Button } from "../Button/Button.tsx";

export const ZoomControls = ({
  zoom,
  onZoomSet,
  defaultZoom,
  zoomableComponentId,
  zoomableComponentRealSize,
}: {
  zoom: number;
  onZoomSet: (zoom: number) => void;
  defaultZoom: number;
  zoomableComponentRealSize: { width: number; height: number };
  zoomableComponentId: string;
}) => {
  const fitZoom = useFitZoom({
    onFitZoomComputed: onZoomSet,
    zoomableComponentId,
    zoomableComponentRealSize,
  });

  return (
    <div className="flex-row items-center gap-100 p-100 rounded-200">
      <Button
        variant="secondary"
        size="md"
        iconName="Minus"
        onClick={() => onZoomSet(Math.max(zoom / 1.2, 0.1))}
        disabled={zoom <= 0.1}
      />
      <Button
        variant="secondary"
        size="md"
        onClick={() => onZoomSet(defaultZoom)}
        className="w-1200"
      >
        {Math.round(zoom * 100)}%
      </Button>
      <Button
        variant="secondary"
        size="md"
        iconName="Plus"
        onClick={() => onZoomSet(Math.min(zoom * 1.2, 5))}
        disabled={zoom >= 5}
      />
      <Button
        variant="secondary"
        size="md"
        iconName="Maximize"
        onClick={fitZoom}
      />
    </div>
  );
};
